const proxyPathPrefix = '/app/proxy/';

const RootRouteRedirectionsHandler = () => {
  const { pathname, search, hash } = window.location;

  if (pathname.startsWith(proxyPathPrefix)) {
    window.location.href = `/app/#/${pathname.replace(
      proxyPathPrefix,
      '',
    )}${search}${hash}`;
  }

  return null;
};

export default RootRouteRedirectionsHandler;
